export default __webpack_public_path__ + "static/media/tennis-champions-thumbnail.d9b9ae55.png";